import {
  SET_PERCENTAGE,
  SET_ACTIVE_STEP,
  SET_USER_COMING_FROM_BUILD_FLOW
} from "../../actionTypeConstants/ml2.0/OnboardingBreadcrumb";

const initialState = {
  items: [
    {
      label: "Automation",
      value: 1,
      goToUrl: "/onboarding"
    },
    {
      label: "Demo Builds",
      value: 2,
      goToUrl: "/build"
    },
    {
      label: "Select Framework",
      value: 3,
      goToUrl: "/onboarding/main"
    },
    {
      label: "Configure your Test",
      value: 4,
      goToUrl: "/configure"
    }
  ],
  percentageComplete: 33,
  activeStep: 2,
  isUserComingFromBuildFlow: false
};

export default function reducer(state = initialState, action = {}) {
  const { payload } = action;

  switch (action.type) {
    case SET_PERCENTAGE: {
      return {
        ...state,
        percentageComplete: payload
      };
    }

    case SET_ACTIVE_STEP: {
      return {
        ...state,
        activeStep: payload
      };
    }

    case SET_USER_COMING_FROM_BUILD_FLOW: {
      return {
        ...state,
        isUserComingFromBuildFlow: payload
      };
    }

    default:
      return state;
  }
}
